export default "__VITE_ASSET__BQndzavW__"